import { i18next } from '@yola/ws-sdk';
import elementSettings from 'src/js/modules/element-settings';
import getUniqueValues from 'src/js/modules/utils/get-unique-values';
import controlIds from '../constants/control-ids';
import settingIds from '../constants/setting-ids';
import attributes from '../constants/attributes';
import computeCornersFallback from '../helpers/compute-corners-fallback';
import computeSpacingFallback from '../helpers/compute-spacing-fallback';
import getColorScheme from './color-scheme';
import getCorners from './corners';
import getHorizontalContentAlignment from './horizontal-content-alignment';
import getHorizontalSpacing from './horizontal-spacing';
import getVerticalContentAlignment from './vertical-content-alignment';
import getVerticalSpacing from './vertical-spacing';

const {
  helpers: { getTargetElementIds },
} = elementSettings;

const getColumnControlSettings = (elementId) => {
  const settingId = settingIds.THIS_COLUMN;
  const elementIds = getTargetElementIds(elementId);

  const controlSettings = {
    [controlIds.COLOR_SCHEME]: getColorScheme(settingId, {
      elementIds,
    }),
    [controlIds.HORIZONTAL_CONTENT_ALIGNMENT]: getHorizontalContentAlignment(settingId, {
      elementIds,
    }),
    [controlIds.VERTICAL_CONTENT_ALIGNMENT]: getVerticalContentAlignment(settingId, {
      elementIds,
    }),
    [controlIds.BORDER]: {
      settingId,
      id: controlIds.BORDER,
      title: i18next.t('Border'),
      attributes: [attributes.BORDER],
      elementIds,
    },
    [controlIds.SHADOW]: {
      settingId,
      id: controlIds.SHADOW,
      title: i18next.t('Shadow'),
      attributes: [attributes.SHADOW],
      elementIds,
    },
    [controlIds.CORNERS]: getCorners(settingId, {
      elementIds,
    }),
    [controlIds.VERTICAL_SPACING]: getVerticalSpacing(settingId, {
      elementIds,
    }),
    [controlIds.HORIZONTAL_SPACING]: getHorizontalSpacing(settingId, {
      elementIds,
    }),
  };

  return {
    ...controlSettings,
    [controlIds.CORNERS_SECTION]: {
      settingId,
      id: controlIds.CORNERS_SECTION,
      title: i18next.t('Corners'),
      elementIds: getUniqueValues(controlSettings[controlIds.CORNERS].elementIds),
      attributes: getUniqueValues(controlSettings[controlIds.CORNERS].attributes),
      computeFallbackValue: computeCornersFallback,
    },
    [controlIds.SPACING_SECTION]: {
      settingId,
      id: controlIds.SPACING_SECTION,
      title: i18next.t('Spacing'),
      elementIds: getUniqueValues([
        ...controlSettings[controlIds.VERTICAL_SPACING].elementIds,
        ...controlSettings[controlIds.HORIZONTAL_SPACING].elementIds,
      ]),
      attributes: getUniqueValues([
        ...controlSettings[controlIds.VERTICAL_SPACING].attributes,
        ...controlSettings[controlIds.HORIZONTAL_SPACING].attributes,
      ]),
      computeFallbackValue: computeSpacingFallback,
    },
  };
};

export default getColumnControlSettings;
